
export const contactsDetails = {
    phone: "+91 7338881050",
    phone2: "+91 8248617484",
    email: "vrbuilders.office@gmail.com",
    location: "New No. 7/1, Old No. 151, Thiruvalluvar Nagar, V.O.C. Street, Rathinamangalam, Chennai, TN",
    postalCode: "600127",
    locationLink: "https://www.google.com/maps/place/V+R+BUILDERS+AND+PROMOTERS/@12.856685,80.13481,16z/data=!4m6!3m5!1s0x3a5259003df2fc11:0xbc276de81ecf468b!8m2!3d12.8566849!4d80.1348102!16s%2Fg%2F11yn34fvrb?hl=en&entry=ttu&g_ep=EgoyMDI2MDEyNy4wIKXMDSoASAFQAw%3D%3D",
}

export const locationLink = "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3889.7923411184347!2d80.13481019999999!3d12.856684899999998!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a5259003df2fc11%3A0xbc276de81ecf468b!2sV%20R%20BUILDERS%20AND%20PROMOTERS!5e0!3m2!1sen!2sin!4v1768235781447!5m2!1sen!2sin";

